import { render } from "./CompanyRequestInternDialog.vue?vue&type=template&id=5c810840&scoped=true"
import script from "./CompanyRequestInternDialog.vue?vue&type=script&lang=js"
export * from "./CompanyRequestInternDialog.vue?vue&type=script&lang=js"

import "./CompanyRequestInternDialog.vue?vue&type=style&index=0&id=5c810840&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c810840"]])

export default __exports__